import { Menu, MenuItem, Tooltip } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { NOTION_MENU_PAPER_SX } from '@/apps/latest/shared/styles/menuStyles'

interface Props {
  anchorEl: HTMLElement | null
  onClose: () => void
  onBulkReplace: () => void
  onRegenerate: () => void
  canRegenerate: boolean
  regenerateTooltip: string
  isRegeneratePending: boolean
  canDeleteRecording: boolean
  onDeleteRecording: () => void
}

// 録音後 view の ⋯ メニュー (一括置換 / 再生成 / 録音削除)。
// 記録を仕上げる途中で手が伸びるものだけを残し、見る / 学ぶ / 作る / 当社へ伝えるは
// ページ下部の RecordActionRow へ出した (yakureki-back log/231 D1)。
// 開閉と各アクションは親 (PostRecordingView) が握る。
export const PostRecordingMoreMenu = ({
  anchorEl,
  onClose,
  onBulkReplace,
  onRegenerate,
  canRegenerate,
  regenerateTooltip,
  isRegeneratePending,
  canDeleteRecording,
  onDeleteRecording,
}: Props) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      slotProps={{ paper: { sx: NOTION_MENU_PAPER_SX } }}
    >
      <MenuItem onClick={onBulkReplace}>一括置換</MenuItem>
      {/* 再生成: disabled は gray out のみ. 長い理由は tooltip で hover 時だけ出す. */}
      <Tooltip title={canRegenerate ? '' : regenerateTooltip} placement="left">
        <span>
          <MenuItem
            disabled={isRegeneratePending || !canRegenerate}
            onClick={onRegenerate}
            sx={{ width: '100%' }}
          >
            再生成
          </MenuItem>
        </span>
      </Tooltip>
      {/* 録音削除 (= detach-nsips). NSIPS 由来かつ再生成中でないときだけ出す. */}
      {canDeleteRecording && (
        <MenuItem
          onClick={onDeleteRecording}
          sx={{ color: colorTokens.fg.muted }}
        >
          録音を削除
        </MenuItem>
      )}
    </Menu>
  )
}
